"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var docs_1 = require("./docs");
var appContainer = document.getElementById('app');
ReactDOM.render(React.createElement(docs_1.DocsApp, null), appContainer, function () { return; });



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 126
// module chunks = 0